/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { styled, Typography } from "@mui/material";
import React from "react";

const MainContainer = styled("div")(({ theme }) => ({
  gap: "24px",
  position: "relative",
  display: "inline-flex",
  flexWrap: "wrap",
  height: "min-content",

  [theme.breakpoints.down("lg")]: {
    padding: 0,
    width: "100%",
    marginBottom: "8px",
    rowGap: "24px",
  },
  [theme.breakpoints.down("sm")]: {
    marginBottom: "8px",
  },
}));

const FiltersTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h4,
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}));

interface FilterCardProps {
  title?: string;
  children: React.ReactNode[] | React.ReactNode;
}

export const FiltersCard: React.FC<FilterCardProps> = (props) => {
  return (
    <MainContainer>
      {props.title && <FiltersTitle variant="h2">{props.title}</FiltersTitle>}
      {props.children}
    </MainContainer>
  );
};
